module.exports = __webpack_public_path__ + "870759daa7fb2332982b06b6c64aa150.svg";


//////////////////
// WEBPACK FOOTER
// ./src/viega-common/components/viega-logo/img/viega-logo.svg
// module id = tbsv
// module chunks = 5